import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';

import { user } from 'services';
import { Toggle, StyledField, ErrorMsg } from 'libs/form';
import { ButtonContainer, Submit } from 'libs/ui';

const MIN_LOGIN_LENGTH = 5;

const validate = (values) => {
  const errors = {};
  if (!values.lk_login && !values.lkpwd) {
    errors._error = '13';
  }
  return errors;
};

const LkFormInner = (props) => {
  const { lk_login, handleSubmit, submitting, error, loginValue, pwdValue } = props;
  const { t } = useTranslation();

  const useLogin = user.canUserLogin();
  const rightUpdate = user.haveRight('clients.update');
  // account exists once a login has been issued (it is created together with a password)
  const hasAccount = Boolean(lk_login);

  const validateLogin = useCallback(
    (value) => {
      const login = value?.toString().trim();
      if (!login) {
        // existing account must keep a login; for a new account it is optional (generated on create)
        return hasAccount ? t('validation.Обязательное поле') : undefined;
      }
      if (login.length < MIN_LOGIN_LENGTH) {
        return t('errors.Логин должен быть не менее 5 символов');
      }
      return undefined;
    },
    [t, hasAccount],
  );

  const validatePassword = useCallback(
    (value, allValues) => {
      const login = allValues?.lk_login?.toString().trim();
      // no account yet: a login can only be saved together with a password (that is what creates the account)
      if (!hasAccount && login && !value) {
        return t('validation.Для создания ЛК укажите пароль');
      }
      return undefined;
    },
    [t, hasAccount],
  );

  if (!useLogin) {
    return null;
  }

  const invalid = !loginValue && !pwdValue;
  // console.log('invalid', invalid, loginValue, pwdValue);
  return (
    <form onSubmit={handleSubmit}>
      <ErrorMsg theme="dark" message={error} />
      <StyledField validate={validateLogin} type="text" label={t('form.Логин ЛК')} name="lk_login" withoutSpaces className="medium-field" />
      <StyledField validate={validatePassword} type="text" label={t('form.Пароль ЛК')} name="lkpwd" noaf={true} withoutSpaces className="medium-field" />
      {lk_login && <Toggle className="green-red force-gray medium-field" type="toggle" label={t('form.Безлимитный')} name="lk_unlimited" />}
      <br />
      {rightUpdate && (
        <ButtonContainer>
          <Submit disabled={submitting || invalid} />
        </ButtonContainer>
      )}
    </form>
  );
};

const LkForm0 = reduxForm({
  form: 'LKForm',
  enableReinitialize: true,
  // validate,
})(LkFormInner);

const selector = formValueSelector('LKForm');

const mapStateToProps = (state) => {
  // Выборка одного значения (вернет примитив)
  const lk_login = selector(state, 'lk_login');
  const lkpwd = selector(state, 'lkpwd');
  return {
    loginValue: lk_login,
    pwdValue: lkpwd,
  };
};

export const LkForm = connect(mapStateToProps)(LkForm0);
